import {
  EntityStatusAuth,
  EntityStatusDesc,
} from '../../../models/entity.model'
import {
  GoodsReturnChangeStatusAction,
  GoodsReturnPermission,
  GoodsReturnStatus,
} from '../models/goods-return.types'

export const GOODS_RETURN_STATUSES: EntityStatusDesc<GoodsReturnStatus>[] = [
  {
    code: 'RETURNING',
    name: 'Pending',
    tooltip: 'Goods return waiting for the goods',
    primary: true,
  },
  {
    code: 'RECEIVED',
    name: 'RECEIVED',
    tooltip: 'Goods return received by the relevant warehouse',
    primary: true,
  },
  {
    code: 'CLOSED',
    name: 'CLOSED',
    tooltip: 'Goods return management ended',
    primary: true,
  },
  {
    code: 'CANCELED',
    name: 'CANCELED',
    tooltip: 'Goods return canceled',
    primary: false,
  },
]

export const GOODS_RETURN_ACTIONS: EntityStatusAuth<
  GoodsReturnChangeStatusAction,
  GoodsReturnPermission
> = {
  ['RETURNING']: {
    permissions: [
      'editHeader',
      'addRows',
      'editRows',
      'saveReturn',
      'cancelReturn',
    ],
    actions: [
      {
        label: 'Mark as received',
        action: 'receive',
      },
    ],
  },
  ['RECEIVED']: {
    permissions: [
      'editHeader',
      'addRows',
      'editRows',
      'saveReturn',
      'cancelReturn',
    ],
    actions: [
      {
        label: 'Mark as pending',
        action: 'return',
      },
      {
        label: 'Close goods return',
        action: 'close',
      },
    ],
  },
  ['CLOSED']: {
    permissions: ['editNotes', 'saveReturn'],
    actions: [
      {
        label: 'Revert to manageable',
        action: 'receive',
      },
    ],
  },
  ['CANCELED']: {
    permissions: ['editNotes', 'saveReturn'],
    actions: [],
  },
}
